import { Comment } from '@insta-club/models';
import { Avatar } from '@insta-club/ui';
import React from 'react';
import Rating from '../Rating';

interface IProps {
    comment: Comment;
}

const CommentItem: React.FC<IProps> = ({ comment }) => {
    return (
        <div className='mb-4 rounded-[12px] bg-gray-100 p-4'>
            <div className='mb-2 flex items-center justify-between gap-3'>
                <div className='flex items-center space-x-1'>
                    <Avatar
                        alt={`${comment.user.first_name} ${comment.user.last_name}`}
                        src={comment.user.image}
                        className='rounded-full object-cover'
                        size={35}
                    />
                    <p className='font-semibold'>
                        {comment.user.first_name} {comment.user.last_name}
                    </p>
                </div>
                <Rating value={isNaN(Number(comment?.rate)) ? 0 : Number(comment?.rate)} style={{ width: '80px' }} />
            </div>

            <p className='mb-2 text-sm font-normal text-gray-600'>{comment.body}</p>
            {/* <div className='text-left'>
                <Button
                    className='text-sm'
                    size='sm'
                    icon={<ReplyIcon className='h-3 w-3 text-white' />}
                    iconPosition='end'
                >
                    پاسخ
                </Button>
            </div> */}
            {comment.replies.length > 0 && (
                <div className='mt-4 pr-6'>
                    {comment.replies.map((reply) => (
                        <div key={reply.id} className='mb-3 rounded-lg bg-gray-200 p-3'>
                            <div className='mb-3 flex items-start justify-between'>
                                <div className='flex items-center gap-2'>
                                    <Avatar
                                        alt={`${reply.user.first_name} ${reply.user.last_name}`}
                                        src={reply.user.image}
                                        className='h-10 w-10 rounded-full object-cover'
                                    />
                                    <p className='text-sm font-semibold'>
                                        {reply.user.first_name} {reply.user.last_name}
                                    </p>
                                </div>

                                <p className='text-left text-xs text-gray-500'>
                                    {reply.created_at.dayOfWeek} {reply.created_at.day}/{reply.created_at.month}/
                                    {reply.created_at.year}
                                </p>
                            </div>
                            <p className='text-sm'>{reply.body}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CommentItem;

